export const PROCEED_TO_EVENT_QUERY_PARAMETER = "proceed";
export const PROCEED_TO_EVENT_QUERY_PARAMETER_VALUE = "true";
